function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import React from 'react';
import { ThemeProvider, LocaleProvider } from 'oskari-ui/util';
import { MapLayers } from './MapLayers/MapLayers';
import ReactDOM from 'react-dom';
import { MapLayersHandler } from '../handler/MapLayersHandler';

/**
 * @class Oskari.mapframework.bundle.publisher.view.PanelMapLayers
 *
 * Represents a layer listing view for the publisher as an Oskari.userinterface.component.AccordionPanel
 * and control for the published map layer selection plugin. Has functionality to promote layers
 * to users and let the user select base layers for the published map.
 */
Oskari.clazz.define('Oskari.mapframework.bundle.publisher2.view.PanelMapLayers',
/**
 * @method create called automatically on construction
 * @static
 * @param {Object} sandbox
 * @param {Object} mapmodule
 * @param {Object} localization
 *       publisher localization data
 * @param {Oskari.mapframework.bundle.publisher2.instance} instance the instance
 */
function (tools, sandbox, mapmodule, localization, instance) {
  this.loc = localization;
  this.instance = instance;
  this.sandbox = sandbox;
  this.mapModule = mapmodule;
  this.isDataVisible = false;
  this.tools = tools || [];
  this.tools = _toConsumableArray(this.tools).sort(function (a, b) {
    return a.index - b.index;
  });
  this.config = {
    layers: {
      promote: [{
        text: this.loc.layerselection.promote,
        id: [] // 24 , 203
      }],
      preselect: [] // 'base_35'
    }
  };
  this.showLayerSelection = false;
  this.panel = null;
  this.handler = null;
}, {
  /**
   * @property {Object} eventHandlers
   * @static
   */
  eventHandlers: {
    /**
     * @method AfterMapLayerAddEvent
     * @param {Oskari.mapframework.event.common.AfterMapLayerAddEvent} event
     *
     * Updates the layerlist
     */
    AfterMapLayerAddEvent: function AfterMapLayerAddEvent() {
      this._notifyHandler();
    },
    /**
     * @method AfterMapLayerRemoveEvent
     * @param {Oskari.mapframework.event.common.AfterMapLayerRemoveEvent} event
     *
     * Updates the layerlist
     */
    AfterMapLayerRemoveEvent: function AfterMapLayerRemoveEvent() {
      this._notifyHandler();
    },
    /**
     * @method AfterRearrangeSelectedMapLayerEvent
     * @param {Oskari.mapframework.event.common.AfterRearrangeSelectedMapLayerEvent} event
     *
     * Updates the layerlist
     */
    AfterRearrangeSelectedMapLayerEvent: function AfterRearrangeSelectedMapLayerEvent() {
      this._notifyHandler();
    },
    /**
     * @method MapLayerEvent
     * @param {Oskari.mapframework.event.common.MapLayerEvent} event
     *
     * Calls flyouts handlePanelUpdate() and handleDrawLayerSelectionChanged() functions
     */
    MapLayerEvent: function MapLayerEvent(event) {
      if (event.getOperation() === 'update') {
        this._notifyHandler();
      }
    },
    /**
     * @method MapLayerVisibilityChangedEvent
     */
    MapLayerVisibilityChangedEvent: function MapLayerVisibilityChangedEvent() {
      this._notifyHandler();
    }
  },
  _notifyHandler: function _notifyHandler() {
    var _this$handler;
    (_this$handler = this.handler) === null || _this$handler === void 0 || _this$handler.updateSelectedLayers();
  },
  /**
   * @method init
   * Creates the Oskari.userinterface.component.AccordionPanel where the UI is rendered
   */
  init: function init(data) {
    var _this = this;
    for (var p in this.eventHandlers) {
      if (this.eventHandlers.hasOwnProperty(p)) {
        this.sandbox.registerForEventByName(this, p);
      }
    }
    this.handler = new MapLayersHandler(this.tools, this.instance.getSandbox(), function () {
      return _this._updateUI();
    });
    return this.handler.init(data);
  },
  /**
   * @method onEvent
   * @param {Oskari.mapframework.event.Event} event a Oskari event object
   * Event is handled forwarded to correct #eventHandlers if found or discarded if not.
   */
  onEvent: function onEvent(event) {
    var handler = this.eventHandlers[event.getName()];
    if (!handler) {
      return;
    }
    return handler.apply(this, [event]);
  },
  getName: function getName() {
    return 'Oskari.mapframework.bundle.publisher2.view.PanelMapLayers';
  },
  /**
   * Returns the UI panel and populates it with the data that we want to show the user.
   *
   * @method getPanel
   * @return {Oskari.userinterface.component.AccordionPanel}
   */
  getPanel: function getPanel() {
    if (!this.panel) {
      this.panel = Oskari.clazz.create('Oskari.userinterface.component.AccordionPanel');
      this.panel.setTitle(this.loc.mapLayers.label);
      this._updateUI();
    }
    return this.panel;
  },
  /**
   * Returns the state of the plugin.
   *
   * @method isEnabled
   * @return {Boolean} true if the plugin is visible on screen.
   */
  isEnabled: function isEnabled() {
    return this.handler.getState().showLayerSelection;
  },
  /**
   * @method getValues
   * @return {Object}
   */
  getValues: function getValues() {
    // just return empty -> tools and their plugins' configs get returned by the layout panel, which has all the tools
    return null;
  },
  /**
   * Returns any errors found in validation (currently doesn't check anything) or an empty
   * array if valid. Error object format is defined in Oskari.userinterface.component.FormInput
   * validate() function.
   *
   * @method validate
   * @return {Object[]}
   */
  validate: function validate() {
    var errors = [];
    return errors;
  },
  /**
   * Populates the map layers panel in publisher
   *
   * @method _updateUI
   * @private
   */
  _updateUI: function _updateUI() {
    if (!this.panel) {
      return;
    }
    var contentPanel = this.panel.getContainer();
    ReactDOM.render(/*#__PURE__*/React.createElement(ThemeProvider, null, /*#__PURE__*/React.createElement(LocaleProvider, {
      value: {
        bundleKey: 'Publisher2'
      }
    }, /*#__PURE__*/React.createElement(MapLayers, {
      state: this.handler.getState(),
      controller: this.handler.getController()
    }))), contentPanel[0]);
  },
  /**
  * Stop panel.
  * @method stop
  * @public
  **/
  stop: function stop() {
    this.handler.stop();
  }
});